'use client';

import { ReactNode } from 'react';
import * as styles from './info-card.css';

export interface InfoCardProps {
  icon?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  /** Optional override for the testid root selector. */
  'data-id'?: string;
}

/**
 * Generic white card with a tinted icon, title and subtitle.
 * Used for the restaurant card (Pickup) and the dine-in card (Table).
 */
export const InfoCard = ({ icon, title, subtitle, ...rest }: InfoCardProps) => (
  <div className={styles.card} {...rest}>
    {icon ? <div className={styles.iconWrap}>{icon}</div> : null}
    <div className={styles.body}>
      <div className={styles.title}>{title}</div>
      {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
    </div>
  </div>
);
